export enum ContactType {
  customerOnly = 'customerOnly',
  supplierOnly = 'supplierOnly',
  customerAndSupplier = 'customerAndSupplier',
}
export enum SyncEmailName {
  email1 = 'email1',
  email2 = 'email2'
}
